// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    trialCoachesCallbackId: 21,
    salesInquiriesId: 60423,
};
